import { Component, Input } from '@angular/core';
import { IconName, IconNamesEnum } from 'ngx-bootstrap-icons';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-sidebar-cell',
  templateUrl: './sidebar-cell.component.html',
  styleUrls: ['./sidebar-cell.component.scss'],
})
export class SidebarCellComponent {
  @Input() name?: string;
  @Input() icon?: string | IconName;
  @Input() iconType?: 'iconly' | 'bs' = 'iconly';
  @Input() isActive = false;
  @Input() onlyDesktop = false;
  @Input() warningMessage: string | undefined = undefined;

  get iconBs(): IconNamesEnum | IconName {
    return this.icon as IconName;
  }
}
